import { ComponentType } from 'react';

import { Table } from 'components/Display/Table/Table';

export type TableHeader = {
  key?: string;
  label: string;
  invisible?: boolean;
  alignRight?: boolean;
  className?: string;
  tooltip?: string;
  sortable?: boolean;
};

export type SortDirection = 'asc' | 'desc';

export type SortState = {
  key: string;
  direction: SortDirection;
} | null;

export type TableItem = {
  element: React.ReactNode;
  key: string;
  className?: string;
  options?: Pick<Parameters<typeof Table.Cell>[0], 'withHighlight'>;
  /**
   * Caps the cell content at `max-w-xs`, truncates it, and shows a tooltip only on overflow.
   * Pass a narrower `max-w-*` in `className` to cap the column tighter.
   */
  longText?: boolean;
};

export type PaginationSelectorType = {
  display: ComponentType;
  pageKey: string;
  selected?: boolean;
  disabled?: boolean;
  className?: string;
};

export enum PageSelectorKey {
  ellipsisStart = 'ellipsisStart',
  ellipsisEnd = 'ellipsisEnd',
  forwardArrow = 'forwardArrow',
  backwardArrow = 'backwardArrow',
}
